(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kama-bundle-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kama-bundle-carousel')) {
    class KamaBundleCarousel extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.slides = [...this.querySelectorAll('.kgw-bundle-slide')];
        if (this.slides.length <= 2) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.index = Math.max(0, this.slides.findIndex(slide => slide.dataset.slot === '0' && slide.classList.contains('is-current')));
        this.step = this.slides.length === 3 ? 1 : 2;
        this.request = 0;
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches || navigator.connection?.saveData || window.Shopify?.designMode;
        this.visible = false;
        this.hovered = false;
        this.ignoreHover = false;
        this.toggle = this.querySelector('[data-bundle-toggle]');
        this.querySelector('.kgw-bundle-controls').hidden = false;
        this.querySelector('[data-bundle-prev]').addEventListener('click', () => this.navigate(-1), options);
        this.querySelector('[data-bundle-next]').addEventListener('click', () => this.navigate(1), options);
        this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = Boolean(this.userPaused); }, options);
        this.toggle.addEventListener('pointercancel', () => { this.toggleIntent = null; }, options);
        this.toggle.addEventListener('click', event => {
          const wasPaused = event.detail && typeof this.toggleIntent === 'boolean' ? this.toggleIntent : this.userPaused;
          this.toggleIntent = null;
          this.userPaused = !wasPaused;
          this.ignoreHover = !this.userPaused;
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.ignoreHover = false;
          this.updatePlayback();
        }, options);
        this.addEventListener('focusin', () => this.pause(), options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.pause();
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.navigate(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        const viewport = this.querySelector('.kgw-bundle-viewport');
        viewport.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) { this.touch = null; return; }
          this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
          this.pause();
        }, { ...options, passive: true });
        viewport.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          this.suppressClickUntil = Date.now() + 700;
          this.navigate(dx < 0 ? 1 : -1);
        }, { ...options, passive: true });
        viewport.addEventListener('touchcancel', () => { this.touch = null; }, options);
        viewport.addEventListener('click', event => {
          if (Date.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
        }, { ...options, capture: true });
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => {
          this.pause();
          if (this.motion.matches) this.finishTransition?.();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
          if (this.visible) this.preloadNextPair();
          this.updatePlayback();
        }, { threshold: [0, .25] });
        this.observer.observe(this);
        this.updatePlayback();
      }

      pause() { this.userPaused = true; this.updatePlayback(); }

      updatePlayback() {
        clearTimeout(this.timer);
        this.dataset.paused = String(Boolean(this.userPaused));
        this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (!this.isConnected || this.animating || this.userPaused || !this.visible || document.hidden || (this.hovered && !this.ignoreHover)) return;
        this.timer = setTimeout(() => this.show((this.index + this.step) % this.slides.length, false, 1), this.interval);
      }

      loadImage(index) {
        const slide = this.slides[index];
        const template = slide.querySelector('template');
        if (template) {
          const image = template.content.querySelector('img').cloneNode(true);
          image.loading = 'eager';
          template.replaceWith(image);
        }
        return slide.querySelector('img');
      }

      navigate(direction) {
        this.pause();
        this.show((this.index + direction * this.step + this.slides.length) % this.slides.length, true, direction);
      }

      preloadNextPair() {
        this.loadImage((this.index + this.step) % this.slides.length);
        this.loadImage((this.index + this.step + 1) % this.slides.length);
      }

      async show(index, manual, direction = 1) {
        if (this.animating || index === this.index) return;
        const request = ++this.request;
        const indices = [index, (index + 1) % this.slides.length];
        const images = indices.map(position => this.loadImage(position));
        await Promise.all(images.map(image => image.decode().catch(() => {})));
        if (!this.isConnected || request !== this.request) return;
        if (images.some(image => !image.naturalWidth) || (!manual && (this.userPaused || !this.visible || document.hidden || (this.hovered && !this.ignoreHover)))) {
          this.updatePlayback();
          return;
        }
        const previousIndices = [this.index, (this.index + 1) % this.slides.length];
        const moving = [];
        this.animating = true;
        this.setAttribute('data-animating', '');
        clearTimeout(this.timer);
        if (this.slides.some(slide => slide.contains(document.activeElement))) this.querySelector('[data-bundle-next]').focus();
        this.slides.forEach((slide, position) => {
          const slot = indices.indexOf(position);
          const previousSlot = previousIndices.indexOf(position);
          const active = slot !== -1;
          slide.classList.toggle('is-current', active);
          slide.classList.toggle('is-leaving', !active && previousSlot !== -1);
          slide.inert = !active;
          if (active) { slide.dataset.slot = String(slot); slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
          else { slide.setAttribute('aria-hidden', 'true'); slide.tabIndex = -1; }
          if (active || previousSlot !== -1) {
            const from = active ? (previousSlot !== -1 ? previousSlot - slot : direction * this.step) * 100 : 0;
            const to = active ? 0 : -direction * this.step * 100;
            moving.push({ slide, from, to });
          }
        });
        const duration = this.motion.matches || !this.visible || document.hidden ? 0 : 650;
        const animations = duration ? moving.map(({ slide, from, to }) => slide.animate(
          [{ transform: `translate3d(${from}%, 0, 0)` }, { transform: `translate3d(${to}%, 0, 0)` }],
          { duration, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'both' }
        )) : [];
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          this.slides.forEach(slide => slide.classList.remove('is-leaving'));
          animations.forEach(animation => animation.cancel());
          this.removeAttribute('data-animating');
          this.animating = false;
          this.index = index;
          this.querySelector('[data-bundle-current]').textContent = indices.map(position => String(position + 1).padStart(2, '0')).join(indices[1] > indices[0] ? '–' : ', ');
          if (manual) this.querySelector('.kgw-bundle-status').textContent = indices.map(position => `${this.slides[position].dataset.position}: ${this.slides[position].dataset.title}`).join('. ');
          if (this.visible) this.preloadNextPair();
          this.finishTransition = null;
          this.updatePlayback();
        };
        this.finishTransition = finish;
        await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
        finish();
      }

      disconnectedCallback() {
        this.finishTransition?.();
        clearTimeout(this.timer);
        this.request++;
        this.observer?.disconnect();
        this.events?.abort();
        this.events = null;
      }
    }
    customElements.define('kama-bundle-carousel', KamaBundleCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kama-recipe-card"] && !Shopify.designMode) return;
  try {
    let kamaRecipeTabSequence = 0;
function kamaInitRecipeTabs() {
 document.querySelectorAll('[data-kama-print]').forEach(button => button.hidden = false);
 document.querySelectorAll('[data-kama-recipe]').forEach(card => {
  if (card.dataset.tabsReady) return;
  const list = card.querySelector('[data-kama-tabs]');
  const panels = [...card.querySelectorAll('[data-kama-panel]')];
  if (!list || panels.length < 2) return;
  const prefix = 'kama-recipe-tabs-' + (++kamaRecipeTabSequence);
  const buttons = panels.map((panel, index) => {
   const button = document.createElement('button');
   button.type = 'button'; button.id = prefix + '-tab-' + index;
   button.textContent = panel.dataset.tabLabel;
   button.setAttribute('role', 'tab');
   panel.id = prefix + '-panel-' + index;
   panel.setAttribute('role', 'tabpanel');
   panel.setAttribute('aria-labelledby', button.id);
   panel.tabIndex = 0;
   button.setAttribute('aria-controls', panel.id);
   list.append(button);
   return button;
  });
  function activate(index, focus) {
   buttons.forEach((button, i) => {
    button.setAttribute('aria-selected', String(i === index));
    button.tabIndex = i === index ? 0 : -1;
    if (i !== index) {
     panels[i].querySelectorAll('video').forEach(video => video.pause());
     panels[i].querySelectorAll('iframe').forEach(frame => {
      try {
       const origin = new URL(frame.src).origin;
       if (origin === 'https://www.youtube.com' || origin === 'https://www.youtube-nocookie.com') frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), origin);
       if (origin === 'https://player.vimeo.com') frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), origin);
      } catch {}
     });
    }
    panels[i].hidden = i !== index;
   });
   if (focus) buttons[index].focus({preventScroll:true});
  }
  buttons.forEach((button, index) => {
   button.addEventListener('click', () => activate(index, false));
   button.addEventListener('keydown', event => {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = buttons.length - 1;
    if (next !== undefined) { event.preventDefault(); activate(next, true); }
   });
  });
  activate(0, false); card.dataset.tabsReady = 'true'; list.hidden = false;
 });
}
kamaInitRecipeTabs();
document.addEventListener('shopify:section:load', kamaInitRecipeTabs);
document.addEventListener('click', event => {
 const jump = event.target.closest('a[href="#kama-recipe"]');
 if (jump && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
  const card = document.getElementById('kama-recipe');
  if (!card) return;
  event.preventDefault();
  const panel = jump.hasAttribute('data-kama-jump-video')
   ? card.querySelector('[data-kama-video-panel]')
   : card.querySelector('.kj__ingredients') || card.querySelector('.kj__method');
  const tab = panel && document.getElementById(panel.getAttribute('aria-labelledby'));
  if (tab) tab.click();
  card.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  (tab || card).focus({preventScroll:true});
  history.replaceState(null, '', '#kama-recipe');
 }
 if (event.target.closest('[data-kama-print]')) window.print();
});

const kamaPrintHiddenPanels = new Set();
function kamaShowPrintPanels() {
 document.querySelectorAll('[data-kama-panel][hidden]').forEach(panel => {
  kamaPrintHiddenPanels.add(panel); panel.hidden = false;
 });
}
function kamaRestorePrintPanels() {
 kamaPrintHiddenPanels.forEach(panel => { if (panel.isConnected) panel.hidden = true; });
 kamaPrintHiddenPanels.clear();
}
window.addEventListener('beforeprint', kamaShowPrintPanels);
window.addEventListener('afterprint', kamaRestorePrintPanels);
window.matchMedia('print').addEventListener('change', event => {
 if (event.matches) kamaShowPrintPanels(); else kamaRestorePrintPanels();
});
  } catch(e) { console.error(e); }
})();

})();
